import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Estilos/entregado.css'; // Asegúrate de que la ruta sea correcta
import NavbarConductor from './navbar';
import Carga from '../../../components/carga';
import { DatePicker } from 'antd';
import moment from 'moment';
import BotonWhatsapp from '../../../newInterface/botonWhatsapp/botonWhatsapp';
import { debounce } from 'lodash'; // Asegúrate de que lodash esté instalado

const { RangePicker } = DatePicker;

/**
 * Componente principal para gestionar los pedidos entregados.
 * @component
 */
function Entregado() {
    const [pedidos, setPedidos] = useState([]);
    // Estado para gestionar el estado de carga
    const [isLoading, setIsLoading] = useState(true);
    // Estado para almacenar las fechas seleccionadas
    const [selectedDates, setSelectedDates] = useState([]);
    const navigate = useNavigate();

    /**
     * Hook de efecto para obtener los pedidos entregados del usuario actual.
     * Se ejecuta una vez al montar el componente.
     */
    useEffect(() => {
        fetchPedidos(); // Obtener todos los pedidos inicialmente
    }, []);

    /**
     * Obtiene los pedidos entregados del usuario actual.
     * @param {Array} [dates=null] - Rango de fechas para filtrar los pedidos.
     */
    const fetchPedidos = async (dates = null) => {
        setIsLoading(true);
        const id_usuario = localStorage.getItem('usuario_id');
        const url = `https://api.99envios.app/api/reporte-pedidos/Entregado/${id_usuario}`;
        try {
            const response = await axios.get(url);
            let filteredData = response.data;

            if (dates && dates.length === 2) {
                const [startDate, endDate] = dates;
                filteredData = filteredData.filter(pedido => {
                    const deliveryDate = moment(pedido.fecha_entrega_repartidor);
                    return deliveryDate.isBetween(startDate, endDate, undefined, '[]'); // Filtrado inclusivo
                });
            }

            setPedidos(filteredData);
        } catch (error) {
            console.error('Error fetching orders:', error);
        }
        setIsLoading(false);
    };

    /**
     * Maneja el cambio de fechas seleccionadas con debounce.
     * @param {Array} dates - Rango de fechas seleccionadas.
     */
    const handleDateChange = debounce((dates) => {
        setSelectedDates(dates);
        if (dates && dates.length === 2) {
            fetchPedidos(dates);
        } else {
            fetchPedidos(); // Obtener todos los pedidos si se borran las fechas
        }
    }, 500); // Tiempo de debounce de 500 milisegundos

    return (
        <div>
            <NavbarConductor title="Entregado" />
            <div className="entregado-container">
                <div className="fecha-pedidos">
                    <h2>Filtrar por rango de fechas:</h2>
                    <RangePicker
                        value={selectedDates}
                        onChange={handleDateChange}
                        format="YYYY-MM-DD"
                    />
                </div>
                {isLoading && <Carga />}
                <div className="resumen-pedidos">
                    <div className="summary-item">
                        <span>Pedidos</span>
                        <span>{pedidos.length}</span>
                    </div>
                    <div className="summary-item">
                        <span>Comisión</span>
                        <span>{pedidos.reduce((acc, pedido) => acc + parseFloat(pedido.costo_envio || 0), 0).toLocaleString('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0, maximumFractionDigits: 0 })}</span>
                    </div>
                </div>
                <div className="lista-pedidos">
                    {pedidos.map((pedido) => (
                        <div key={pedido.ID_pedido} className="pedido">
                                <h4>Pedido #{pedido.ID_pedido}</h4>
                                <p>Cliente: {pedido.nombre_cliente}</p>
                                <p>Costo de Envío: {parseFloat(pedido.costo_envio).toLocaleString('es-CO', { style: 'currency', currency: 'COP' })}</p>
                                <p>Fecha de Entrega: {moment(pedido.fecha_entrega_repartidor).format('YYYY-MM-DD')}</p>
                            <button className="detalle-pedido-btn" onClick={() => navigate(`/conductor/pedidos/${pedido.ID_pedido}`)}>Detalles del pedido</button>
                        </div>
                    ))}
                </div>
            </div>
            <BotonWhatsapp />
        </div>
    );
}

export default Entregado;
